import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";

import NotFound from "components/Library/NotFound";

class ErrorPage extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidUpdate(prevProps) {
    const { data } = this.props;

    if (
      data &&
      data.error &&
      prevProps.location.pathname !== this.props.location.pathname
    ) {
      this.setError(null);
    }
  }

  setError = status => {
    this.props.client.writeData({ data: { error: status } });
  };

  getErrorText = status => {
    let errorText;
    switch (status) {
      case 404:
        errorText = "404! In other words, something went wrong.";
        break;
      case 500:
        errorText = "Our bad! Something went wrong.";
        break;
      default:
        break;
    }
    return errorText;
  };

  render() {
    const { data } = this.props;

    // Mutate staticContext in render https://reacttraining.com/react-router/web/example/static-router
    if (this.props.staticContext) {
      this.props.staticContext.status = data.error;
    }

    if (data && data.error) {
      return <NotFound errorText={this.getErrorText(data.error)} />;
    } else {
      return this.props.children;
    }
  }
}

export default withRouter(ErrorPage);

ErrorPage.propTypes = {
  staticContext: PropTypes.shape({
    status: PropTypes.number,
  }),
  children: PropTypes.node.isRequired,
  client: PropTypes.object.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  data: PropTypes.shape({
    error: PropTypes.number,
  }),
};
